import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography } from "antd";

import PatientLogBook from "../../../components/Tables/PatientLogbook";

import { translate } from "../../../locale";
import { Link } from "react-router-dom";
import { Breadcrumb, Row, Col } from "antd";

const { Title } = Typography;

const LogBook = () => {
  const [logs, setlogs] = useState([]);

  useEffect(() => {
    getpatientlogs();
  }, []);

  const getpatientlogs = async () => {
    // Call service

    setlogs([
      {
        //Cambiar los datos
        monodroug: "Trimebutina",
        brandname: "MIOPROPAN",
        presentation: "30 comprimidos",
        init_date: "09/02/2022",
        end_date: "09/03/2022",
        status: "Activo",
        indication: "INDICATION",
      },
    ]);
  };
  const { username } = useParams();

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl mx-10 items-start pb-10">
      <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
        <Row>
          <Col className="gutter-row" span="24">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/admin">{translate("Inicio")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={`/admin/buscar-paciente/${username}`}>
                  {translate("Resumen individual")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="">{translate("Diario de Registros")}</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
            <Breadcrumb>
              <Breadcrumb.Item>{username}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span="24" className="my-4">
            <Title level={2} className="text-center">
              {translate("Diario de registros")}
            </Title>
          </Col>

          <Col span="24" className="mt-6">
            <PatientLogBook selectedData={logs} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default LogBook;
